export default class ResponsiveSize {
  static breakpoints = {
    xs: 0,
    md: 768,
    lg: 992,
  };

  static sizesByBreakpoint = {
    s: [[0.8, 'rem'], [0.9, 'px'], [1, 'px']],
    m: [[0.61, 'rem'], [0.8, 'px'], [1, 'px']],
    l: [[0.58, 'rem'], [0.8, 'px'], [1, 'px']],
    xl: [[0.4, 'rem'], [0.7, 'px'], [1, 'px']],
  };

  static getCSSValue(value: number | string): string {
    const size = parseInt(`${value}`, 10);

    if (size >= 50) {
      return ResponsiveSize.get(ResponsiveSize.sizesByBreakpoint.xl, size);
    }

    if (size >= 40) {
      return ResponsiveSize.get(ResponsiveSize.sizesByBreakpoint.l, size);
    }

    if (size >= 30) {
      return ResponsiveSize.get(ResponsiveSize.sizesByBreakpoint.m, size);
    }

    return ResponsiveSize.get(ResponsiveSize.sizesByBreakpoint.s, size);
  }

  static getCurrentBreakpoint(): string {
    let bp = 'xs';

    Object.entries(ResponsiveSize.breakpoints).forEach(([key, size]) => {
      if (window.innerWidth >= size) {
        bp = key;
      }
    });

    return bp;
  }

  private static get(sizes: (string|number)[][], value: number): string {
    const sizeInx = Object.keys(this.breakpoints).indexOf(ResponsiveSize.getCurrentBreakpoint());

    const size = sizes[sizeInx];

    const percentage = size[0] as number;
    const unit = size[1] as string;

    switch (unit) {
      case 'rem':
        return `${(value * percentage) / 16}rem`;
      default:
        return `${value * percentage}px`;
    }
  }

  static isMobileBreakpoint(): boolean {
    return ResponsiveSize.getCurrentBreakpoint() === 'xs';
  }

  static isMobileOrTablet(): boolean {
    return ['xs', 'md'].includes(ResponsiveSize.getCurrentBreakpoint());
  }
}
